import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NmdCalculationResponseDto, PrintResultDto } from '../../../core/services/GPRMV1Service.Generated';

import { ValuePerPhaseModel } from '../../../shared/models/value-per-phase.model';
import { DataSetSettingEnum } from '../../../shared/enums/data-set-setting.enum';
import { ENmdProductStatus } from '../../../shared/enums/nmd-product-status.enum';
import { environment } from '../../../../environments/environment';

class MainElementDto {
    readonly colorCode: string;
    readonly id: number;
    readonly name: string;
    readonly value: number;
    readonly percentage: number;

    constructor(id: number, name: string, value: number, colorCode: string, percentage: number) {
        this.colorCode = colorCode;
        this.id = id;
        this.name = name;
        this.value = value;
        this.percentage = percentage;
    }
}

@Component({
    selector: 'app-print-mpg-landscape',
    templateUrl: './print-mpg-landscape.component.html',
    styleUrls: ['./print-mpg-landscape.component.scss'],
    standalone: false
})
export class PrintMpgLandscapeComponent {

    @Input() calculationResults: NmdCalculationResponseDto | null = null;
    @Input() calculationResultsAfter: NmdCalculationResponseDto | null = null;
    @Input() mpgResultTitle: string;
    @Input() isExistingBuildingCal: boolean;
    @Input() selectedDataSet: number;
    @Input() mpgResultTitlePerMainElementTitle: string;
    @Input() printData: PrintResultDto;
    @Input() envirnmentalCategoryTitle: string;
    @Input() environmentEffects: ValuePerPhaseModel[];
    @Input() environmentEffectsAfter: ValuePerPhaseModel[];
    @Input() chartOption: any;
    @Input() currentMainElements: MainElementDto[];
    @Input() afterMainElements: MainElementDto[];
    @Input() codes: {};
    @Input() tableColumns: string[];
    @Input() elementResultTitle: string;

    dataSetSetting = DataSetSettingEnum;
    nmdProductStatusEnum = ENmdProductStatus;
    uploadsImageBaseUrl: string = environment.uploadsBaseUrl;
    // MPG card
    mpgColumns: string[] = ['colorCode', 'name', 'value', 'percentage'];

    // MKI card
    mkiColumns: string[] = ['name', 'mki'];

    colors = [
        '#FF7A00',
        '#FFB500',
        '#FF5257',
        '#DB021F',
        '#ABB4F1',
        '#333E86',
        '#F9D5D6',
        '#FF61A9',
        '#00BBB9',
        '#00B33D',
        '#96DC00',
        '#F458F8',
        '#EA16A2',
        '#FFD600'
    ];

    constructor(private _translate: TranslateService) {
    }
}
